export const languages = [            
    {name: 'English', value: 'en'},
    {name: 'Tiếng việt', value: 'vi'},
];

